import axios from 'axios';
import config from '../config/config';

const API_BASE = `${config.API_BASE}/empresaCreditos`;

export const consultarSaldo = (empresaId) =>
  axios.get(`${API_BASE}/saldo/${empresaId}`);

export const atualizarSaldo = (empresaId, dados) =>
  axios.put(`${API_BASE}/saldo/${empresaId}`, dados);

export const lancarCredito = (dados) =>
  axios.post(`${API_BASE}/credito`, dados);

export const lancarDebito = (dados) =>
  axios.post(`${API_BASE}/debito`, dados);

export const listarLancamentos = (empresaId) =>
  axios.get(`${API_BASE}/lancamentos/${empresaId}`);

export const filtrarLancamentos = (empresaId, params) =>
  axios.get(`${API_BASE}/${empresaId}/lancamentos`, { params });
